<template>
  <svg :width="width" :height="height" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 14C10 12.3431 8.65685 11 7 11C5.34315 11 4 12.3431 4 14C4 15.6569 5.34315 17 7 17C8.65685 17 10 15.6569 10 14ZM6 14C6 13.4477 6.44772 13 7 13C7.55228 13 8 13.4477 8 14C8 14.5523 7.55228 15 7 15C6.44772 15 6 14.5523 6 14Z"
      :fill="color"
    />
    <path
      d="M15 17C16.6569 17 18 15.6569 18 14C18 12.3431 16.6569 11 15 11C13.3431 11 12 12.3431 12 14C12 15.6569 13.3431 17 15 17Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 22C10 20.3431 8.65685 19 7 19C5.34315 19 4 20.3431 4 22C4 23.6569 5.34315 25 7 25C8.65685 25 10 23.6569 10 22ZM6 22C6 21.4477 6.44772 21 7 21C7.55228 21 8 21.4477 8 22C8 22.5523 7.55228 23 7 23C6.44772 23 6 22.5523 6 22Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 19C16.6569 19 18 20.3431 18 22C18 23.6569 16.6569 25 15 25C13.3431 25 12 23.6569 12 22C12 20.3431 13.3431 19 15 19ZM15 21C14.4477 21 14 21.4477 14 22C14 22.5523 14.4477 23 15 23C15.5523 23 16 22.5523 16 22C16 21.4477 15.5523 21 15 21Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26 14C26 12.3431 24.6569 11 23 11C21.3431 11 20 12.3431 20 14C20 15.6569 21.3431 17 23 17C24.6569 17 26 15.6569 26 14ZM22 14C22 13.4477 22.4477 13 23 13C23.5523 13 24 13.4477 24 14C24 14.5523 23.5523 15 23 15C22.4477 15 22 14.5523 22 14Z"
      :fill="color"
    />
    <path
      d="M23 25C24.6569 25 26 23.6569 26 22C26 20.3431 24.6569 19 23 19C21.3431 19 20 20.3431 20 22C20 23.6569 21.3431 25 23 25Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 0H5V2H2C0.89543 2 0 2.89543 0 4V28C0 29.1046 0.89543 30 2 30H28C29.1046 30 30 29.1046 30 28V4C30 2.89543 29.1046 2 28 2H25V0H23V2H7V0ZM28 4V6H2V4H28ZM2 8V28H28V8H2Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CalendarIconOccasional',
  props: {
    width: {
      type: Number,
      default: 30,
    },
    height: {
      type: Number,
      default: 30,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
